const creatureToggle = `

There has been some confusion regarding how creature toggles work. Here is a detailed explanation:

#### General Rules
- Every unit can be freely combined with any **Relic** without restrictions.
- The **Spirit** of a unique soul pet runs separately from others, meaning no blockade (**except from the same spirit**).
- Unit potions are blocked by the same unit or its corresponding **Relic** but **not** by the **Spirit**.

#### Example
It is possible to:
- Activate the **normal Harpy unit**.
- Obtain the **Harpy Relic** from another pet.
- Receive the **Spirit of the Harpy** additionally.

⚠️ However, you **cannot** receive the **Potion of Harpy** effect at the same time because it is blocked by the Harpy unit and its Relic.

#### Additional Possibilities
- A **TR-Relic** from **Pet #1** can be activated.
- A **Spirit** from **Pet #1** can run alongside it.
- A **Harpy Relic** from **Pet #2** can also be active.
- A **Spirit** from **Pet #2** (**except the one from Pet #1**) can be added.
- A **Cerberus Potion** can be used.

➡ **Maximum possible:** **4 "units" on one character + 1 potion.**

Hopefully, this clears up any confusion!`;

export default creatureToggle;
